import React, { useRef, useState, useEffect } from "react";

import { Table, TableBody, TableContainer, TableHead, TableRow,
  TextField, Paper, Button, Checkbox, InputAdornment,
  Divider, Menu, MenuItem, TableSortLabel, Snackbar, IconButton
} from "@mui/material";

import ViewWeekIcon from "@mui/icons-material/ViewWeek";
import SearchIcon from "@mui/icons-material/Search";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import RestoreIcon from "@mui/icons-material/Restore";
import CachedIcon from "@mui/icons-material/Cached";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CloseIcon from "@mui/icons-material/Close";
import { obtenerListadoUsuarios } from "../service/apiService.js";
import { setItems as setUsersItem } from "../provider/Slice/UserSlice";
import DialogUser from "../components/adminsuite/DialogUser.js";

import {
  AddButton,
  StyledTableRow,
  StyledTableCell,
  InputStyle,
  CheckBox,
  StyleTableSortLabel
} from "../SXStyle";

//loaders
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import { useAppDispatch, useAppSelector } from "../provider/app/hooks";

export default function UserAdminSuite() {
  const dispatch = useAppDispatch();
  const usuarios = useAppSelector((state) => state.StoreUsuarios.data);

  const [buscador, setBuscador] = useState("");
  const [data, setData] = useState([]);

  //states del main menu
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);

  // Estado global para el menú
  const [rowAnchorEl, setRowAnchorEl] = useState(null);
  const [menuRowId, setMenuRowId] = useState(null);

  const [registro, setRegistro] = useState();

  const [columnasVisibles, setColumnasVisibles] = useState({
    status: true,
    name: true,
    surname1: true,
    surname2: true,
    title: true,
    email: true,
    phoneNumber: true
  });

  //order columns
  const [order, setOrder] = useState("asc");            // "asc" o "desc"
  const [orderBy, setOrderBy] = useState("type");       // columna ordenada

  //dialog
  const [openDialog, setOpenDialog] = useState();

  //loader
  const [openLoader, setOpenLoader] = useState(true);

  //snackbar de alertas
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
  });

  //cierra el snackbar
  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar({ ...snackbar, open: false });
  };
  

  const abrirMenuColumnas = (event) => {
    setAnchorEl(event.currentTarget);
  };

  //functions del menu table
  const abrirTableMenu = (event, rowId) => {
    setRowAnchorEl(event.currentTarget);
    setMenuRowId(rowId);
  };

  const cerrarTableMenu = () => {
    setRowAnchorEl(null);
    setMenuRowId(null);
  };

  const abrirEditarRegistro = (row) => {
    setRegistro(row);
    setRowAnchorEl(null);
    setMenuRowId(null);
    setOpenDialog(true);
  }

  const abrirCrearNuevoRegistro = () => {
    setRegistro(null);
    setOpenDialog(true);
  }

  const isMenuTableAbierto = (rowId) => {
    return menuRowId === rowId;
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  const sortedData = React.useMemo(
    () => [...data || []].sort(getComparator(order, orderBy)),
    [data, order, orderBy]
  );

  // aplica el filtrado
  useEffect(() => {
    setOpenLoader(true);
    
    // Activa un loader primero
    setTimeout(() => {
      const resultados = usuarios.filter((item) => {
        const valores = Object.values(item);
        return valores.some((valor) => {
          if (typeof valor === "string" || typeof valor === "number") {
            return valor.toString().toLowerCase().includes(buscador);
          }
          return false;
        });
      });
      
      setData(resultados);
      setOpenLoader(false);
    }, 300);

  }, [buscador]);

  
  //recarga el listado al sufrir un cambio
  useEffect(() => {
    setOpenLoader(true);
    
    // Activa un loader primero
    setTimeout(() => {
      setData(usuarios);
      setOpenLoader(false);
    }, 300);
  }, [usuarios]);


  const habilitarVisibilidadColumnas = (checked, column) => {
    setColumnasVisibles((prev) => ({
      ...prev,
      [column]: checked,
    }));
  };

  const resetTable = () => {
    setColumnasVisibles({
      status: true,
      name: true,
      surname1: true,
      surname2: true,
      title: true,
      email: true,
      phoneNumber: true
    });
    setBuscador("");
  };

  const getTogleColumn = (name) => {
    switch(name)
    {
      case "status":
        return "Status";
      case "name":
        return "Nombre";
      case "surname1":
        return "Apelido Paterno";
      case "surname2":
        return "Apelido Materno";
      case "title":
        return "Titulo Profesional";
      case "email":
        return "Email";
      case "phoneNumber":
        return "Teléfono";
    }
  }

  const cargarListadoUsuarios = async() => {
    try
    {
      setOpenLoader(true);
      const result =  await obtenerListadoUsuarios();
      dispatch(setUsersItem(result.data));
    }
    catch (error) //ocurre un error
    {
      console.log({error})
    }
    finally
    {
      setOpenLoader(false);
    }
  }

  //action snackbar
  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleSnackClose}
      >
        <CloseIcon fontSize="small" className="text-amarillo" />
      </IconButton>
    </React.Fragment>
    );

  return (
    <section className="bg-fondo_blanco shadow-xl rounded-lg">
      <div className="flex flex-col h-[82vh] px-12 py-8 mx-auto ">
        <div className="bg-ceniza_light border border-gray-600 rounded-lg shadow-xl p-5 ml-5 h-[75vh] w-full">
          
          <DialogUser 
            open={openDialog}
            setOpen={setOpenDialog}
            registro={registro}
            setSnackbar={setSnackbar}
          />

          {/* Snackbar */}
          <Snackbar
            open={snackbar.open}
            autoHideDuration={6000}
            onClose={handleSnackClose}
            message={snackbar.message}
            action={action}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            ContentProps={{
            sx: {
              color: "#fffcfc"
            },
            }}
          />

          {/* Loader */}
          <Backdrop
            sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
            open={openLoader}
          >
            <CircularProgress color="inherit" />
          </Backdrop>

          {/* Accesos Rapidos */}
          <div className="flex justify-end  mt-6 gap-2">
            <Button
              onClick={() => abrirCrearNuevoRegistro()}
              variant="contained"
              sx={{ ...AddButton, marginRight: "10px" }}
              endIcon={<AddCircleIcon />}
            >
              Crear nuevo
            </Button>

            <TextField
              id="buscar"
              label="Buscar"
              size="small"
              value={buscador}
              defaultValue=""
              className="rounded-lg block w-full bg-inputs border"
              sx={{
                ...InputStyle,
                width: "320px",
                height: "40px",
                marginTop: "12px",
              }}
              onChange={(e) => setBuscador(e.target.value)}
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon className="text-amarillo" fontSize="10" />
                    </InputAdornment>
                  ),
                },
              }}
            />

            {/* Menu de Visibilidad de Columnas */}
            <div>
              <div
                className="border border-gris rounded-md inline-block p-1 h-[40px] mt-[13px] cursor-pointer"
                id="basic-button"
                aria-controls={isMenuOpen ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={isMenuOpen ? "true" : undefined}
                onClick={(e) => abrirMenuColumnas(e)}
              >
                <ViewWeekIcon className="text-amarillo" fontSize="medium" />
              </div>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={isMenuOpen}
                onClose={() => setAnchorEl(null)}
                sx={{ width: "100%", padding: "5px" }}
                slotProps={{
                  list: {
                    "aria-labelledby": "basic-button",
                  },
                }}
              >
                <p className="w-[160px] text-center"> Alternar columnas </p>
                <Divider />

                {Object.entries(columnasVisibles).map(([name, value]) => (
                  <div className="flex">
                    <Checkbox
                      checked={value}
                      name={name}
                      sx={CheckBox}
                      onChange={(e) =>
                        habilitarVisibilidadColumnas(e.target.checked, name)
                      }
                    />
                    <MenuItem style={{ pointerEvents: "none" }}>
                      {getTogleColumn(name)}
                    </MenuItem>
                  </div>
                ))}
              </Menu>
            </div>

            <div
              className="border border-gris rounded-md inline-block p-1 h-[40px] mt-[13px] cursor-pointer"
              onClick={()=>resetTable()}
            >
              <RestoreIcon className="text-amarillo" fontSize="medium" />
            </div>

            <div
              className="border border-gris rounded-md inline-block p-1 h-[40px] mt-[13px] cursor-pointer"
              onClick={()=>cargarListadoUsuarios()}
            >
              <CachedIcon className="text-amarillo" fontSize="medium" />
            </div>
          </div>

          {/* Tabla */}
          <TableContainer
            component={Paper}
            sx={{ maxHeight: "350px", width: "100%", marginTop: "20px" }}
          >
            <Table aria-label="customized table" stickyHeader>
              <TableHead>
                <TableRow>
                  
                  {columnasVisibles.status && (
                    <StyledTableCell 
                      align="center" 
                      sortDirection={orderBy === 'status' ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === 'status'}
                        direction={orderBy === 'status' ? order : 'asc'}
                        onClick={() => handleRequestSort('status')}
                        sx={StyleTableSortLabel}
                      >
                        Status
                      </TableSortLabel>
                    </StyledTableCell>
                  )}
                  
                  {columnasVisibles.name && (
                    <StyledTableCell 
                      align="center"
                      sortDirection={orderBy === 'name' ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === 'name'}
                        direction={orderBy === 'name' ? order : 'asc'}
                        onClick={() => handleRequestSort('name')}
                        sx={StyleTableSortLabel}
                      >
                        Nombre
                      </TableSortLabel>
                    </StyledTableCell>
                  )}
                  
                  {columnasVisibles.surname1 && (
                    <StyledTableCell 
                      align="center"
                      sortDirection={orderBy === 'surname1' ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === 'surname1'}
                        direction={orderBy === 'surname1' ? order : 'asc'}
                        onClick={() => handleRequestSort('surname1')}
                        sx={StyleTableSortLabel}
                      >
                        Apellido Paterno
                      </TableSortLabel>
                    </StyledTableCell>
                  )}
                  
                  {columnasVisibles.surname2 && (
                    <StyledTableCell 
                      align="center"
                      sortDirection={orderBy === 'surname2' ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === 'surname2'}
                        direction={orderBy === 'surname2' ? order : 'asc'}
                        onClick={() => handleRequestSort('surname2')}
                        sx={StyleTableSortLabel}
                      >
                        Apellido Materno
                      </TableSortLabel>
                    </StyledTableCell>
                  )}
                  
                  {columnasVisibles.email && (
                    <StyledTableCell 
                      align="center"
                      sortDirection={orderBy === 'email' ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === 'email'}
                        direction={orderBy === 'email' ? order : 'asc'}
                        onClick={() => handleRequestSort('email')}
                        sx={StyleTableSortLabel}
                      >
                        Email
                      </TableSortLabel>
                    </StyledTableCell>
                  )}
                  
                  {columnasVisibles.phoneNumber && (
                    <StyledTableCell 
                      align="center"
                      sortDirection={orderBy === 'phoneNumber' ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === 'phoneNumber'}
                        direction={orderBy === 'phoneNumber' ? order : 'asc'}
                        onClick={() => handleRequestSort('phoneNumber')}
                        sx={StyleTableSortLabel}
                      >
                        Teléfono
                      </TableSortLabel>
                    </StyledTableCell>
                  )}

                  {columnasVisibles.title && (
                    <StyledTableCell 
                      align="center"
                      sortDirection={orderBy === 'title' ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === 'title'}
                        direction={orderBy === 'title' ? order : 'asc'}
                        onClick={() => handleRequestSort('title')}
                        sx={StyleTableSortLabel}
                      >
                        Titulo Profesional
                      </TableSortLabel>
                    </StyledTableCell>
                  )}

                  <StyledTableCell align="center">
                    <SettingsApplicationsIcon
                      className="text-amarillo"
                      sx={{ fontSize: 30 }}
                    />
                  </StyledTableCell>

                </TableRow>
              </TableHead>
              
              <TableBody>
                {sortedData.map((row, index) => (
                  <StyledTableRow key={index}>
                    
                    {columnasVisibles.status && (
                      <StyledTableCell align="center">
                        <div className="flex justify-center items-center">
                            <RadioButtonCheckedIcon
                              className={
                                row.status == "1" 
                                  ? "text-verde"
                                  : "text-amarillo"
                              }
                            />
                          <p className="ml-2 mt-1"> {row.status  ? "Activo" : "Inactivo"} </p>
                        </div>
                      </StyledTableCell>
                    )}

                    {columnasVisibles.name && (
                      <StyledTableCell align="center">
                        {row.name}
                      </StyledTableCell>
                    )}

                    {columnasVisibles.surname1 && (
                      <StyledTableCell align="center">
                        {row.surname1}
                      </StyledTableCell>
                    )}

                    {columnasVisibles.surname2 && (
                      <StyledTableCell align="center">
                        {row.surname2}
                      </StyledTableCell>
                    )}
                    
                    {columnasVisibles.email && (
                      <StyledTableCell align="center">
                        {row.email}
                      </StyledTableCell>
                    )}

                    {columnasVisibles.phoneNumber && (
                      <StyledTableCell align="center">
                        {row.phone}
                      </StyledTableCell>
                    )}

                    {columnasVisibles.title && (
                      <StyledTableCell align="center">
                        {row.title}
                      </StyledTableCell>
                    )}

                    <StyledTableCell align="center">
                      <div>
                        <div
                          className="cursor-pointer"
                          aria-controls={
                            isMenuTableAbierto(row.id)
                              ? "basic-menu"
                              : undefined
                          }
                          aria-haspopup="true"
                          aria-expanded={
                            isMenuTableAbierto(row.id) ? "true" : undefined
                          }
                          onClick={(e) => abrirTableMenu(e, row.id)}
                        >
                          <MoreHorizIcon
                            className="text-gris"
                            sx={{ fontSize: 25 }}
                          />
                        </div>

                        <Menu
                          id="basic-menu"
                          anchorEl={rowAnchorEl}
                          open={isMenuTableAbierto(row.id)}
                          onClose={() => cerrarTableMenu()}
                          sx={{ width: "100%", padding: "5px" }}
                          slotProps={{
                            list: {
                              "aria-labelledby": "basic-button",
                            },
                          }}
                        >
                          <MenuItem onClick={() => abrirEditarRegistro(row)}>
                            Editar
                          </MenuItem>
                        </Menu>
                      </div>
                    </StyledTableCell>

                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

        </div>
      </div>
    </section>
  );
}
